import type { ShopCartSelection } from '../store/types';
import type { AddOnItem } from '../components/BuyTickets';

/**
 * Type guard to check if an item is a ShopCartSelection
 */
export const isShopCartSelection = (
  item: ShopCartSelection | AddOnItem,
): item is ShopCartSelection => {
  return 'count' in item;
};

/**
 * Helper function to get item ID from either ShopCartSelection or AddOnItem
 */
export const getItemId = (item: ShopCartSelection | AddOnItem): string => {
  return isShopCartSelection(item) ? item.productAK : item.ak;
};

/**
 * Helper function to get item name from either ShopCartSelection or AddOnItem
 */
export const getItemName = (item: ShopCartSelection | AddOnItem): string => {
  return isShopCartSelection(item) ? item.label : item.name ?? item.description;
};

/**
 * Helper function to get item quantity from either ShopCartSelection or AddOnItem
 */
export const getItemQuantity = (
  item: ShopCartSelection | AddOnItem,
): number => {
  return isShopCartSelection(item) ? item.count : item.quantity ?? 0;
};
